"use strict";
var popup_component_1 = require("./popup.component");
exports.NguiPopupComponent = popup_component_1.NguiPopupComponent;
var message_popup_component_1 = require("./message-popup.component");
exports.NguiMessagePopupComponent = message_popup_component_1.NguiMessagePopupComponent;
var popup_module_1 = require("./popup.module");
exports.NguiPopupModule = popup_module_1.NguiPopupModule;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@ngui/popup/dist/index.js
// module id = 246
// module chunks = 4